import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export function BlogImage({ src, alt = "", width, height, borderRadius = "inherit", objectFit = "cover", sx = {}, imgSx = {} }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoaded(false);
    setError(false);
  }, [src]);

  const handleLoad  = () => { setLoaded(true); setError(false); };
  const handleError = () => { setLoaded(true); setError(true); };

  return (
    <Box sx={{ position: "relative", width, height, borderRadius, overflow: "hidden", flexShrink: 0, ...sx }}>
      {!loaded && (
        <Skeleton
          variant="rectangular"
          animation="wave"
          sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", borderRadius }}
        />
      )}
      <Box
        component="img"
        src={src}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
        sx={{
          width: "100%",
          height: "100%",
          objectFit,
          display: loaded ? "block" : "none",
          border: error ? "2px solid #EA001B" : "none",
          borderRadius,
          boxSizing: "border-box",
          ...imgSx,
        }}
      />
    </Box>
  );
}
